import { render, staticRenderFns } from "./ElevatorDetails.vue?vue&type=template&id=c9542674&scoped=true"
import script from "./ElevatorDetails.vue?vue&type=script&lang=js"
export * from "./ElevatorDetails.vue?vue&type=script&lang=js"
import style0 from "./ElevatorDetails.vue?vue&type=style&index=0&id=c9542674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9542674",
  null
  
)

export default component.exports